import React, { useState } from 'react';
import '../styles/Products.css';

const Products = ({ image, index, productInfo, currency }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Get the product information corresponding to the image index
  const { product_name, product_price, product_description } = productInfo[index] || {};

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={`card-container ${isFlipped ? 'flipped' : ''}`}>
      {/* Front Side */}
      <div className='card front'>
        <img src={image.url} alt={product_name} className="product-image" onClick={openModal}/>
        <h3 className="product-name">{product_name}</h3>
        <div>
          {product_price && <span className="product-currency">{currency}</span>}
          <span className='product-price'>{product_price}</span>
        </div>
        <div onClick={handleFlip} className="product-description-container">
          <p className="product-description">Click to see the description</p>
        </div>
      </div>

      {/* Back Side */}
      <div className='card back'>
        <p className="product-description-back">{product_description}</p>
        <div onClick={handleFlip} className="product-description-container">
          <p className="product-description">Click to see the info</p>
        </div>
      </div>

      {/* Modal for Enlarged Image */}
      {isModalOpen && (
        <div className="modal-background" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <span className="close-modal" onClick={closeModal}>&times;</span>
            <img src={image.url} alt={product_name} className="full-image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;